import React from 'react'
import ProductDisposalModal from '../../../components/inventorymng/products/ProductDisposalModal'

const ProductDisposalModalContainer = ({ open, handleClose }) => {
    return (
        <ProductDisposalModal
            open={open}
            handleClose={handleClose} />
    )
}

export default ProductDisposalModalContainer